import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, Descriptions, Divider, Spin, Typography, message } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { retrieveSingleAdminBlacklistedWallet } from '../../methods/redux/reducers/admin-blacklisted-wallets';

const { Title, Text } = Typography;

const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	gap: 1em;

	& .myCard {
		border-radius: 10px;
		gap: 1em;
	}
`;

const SingleBlacklistedWallet = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();
    
    // Support either query param ?id=... or URL param /:id
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id') || location.pathname.split('/').pop();

    const { singleRecord: data, loading } = useAppSelector(
        (store: any) => store.adminBlacklistedWallets
    );

    useEffect(() => {
        if (id) {
            dispatch(retrieveSingleAdminBlacklistedWallet(id as string));
        }
    }, [id, dispatch]);

    return (
        <PageWrapper>
            <Card className="myCard">
                <Button 
                    type="link" 
                    icon={<ArrowLeftOutlined />} 
                    onClick={() => navigate(-1)}
                    style={{ padding: 0, marginBottom: '16px' }}
                >
                    Back to List
                </Button>

                <Title level={3}>Blacklisted Wallet Details</Title>
                <Divider />

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Spin size="large" />
                    </div>
                ) : data ? (
                    <Descriptions bordered column={1}>
                        <Descriptions.Item label="Wallet Address">
                            <Text strong copyable>{data.walletAddress}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="User Email">
                            <Text>{data.userEmail}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Full Name">
                            <Text>{data.userId?.fullName || 'N/A'}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Username">
                            <Text>{data.userId?.username || 'N/A'}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Comment">
                            <Text>{data.comment}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Created At">
                            <Text>{moment(data.createdAt).format('LLL')}</Text>
                        </Descriptions.Item>
                        <Descriptions.Item label="Last Updated">
                            <Text>{moment(data.updatedAt).format('LLL')}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                ) : (
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        <Text type="secondary">Record not found.</Text>
                    </div>
                )}
            </Card>
        </PageWrapper>
    );
};

export default SingleBlacklistedWallet;
